var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Accessory',{attrs:{"idname":"保理客户资料","fileMenuUrlname":"","projectid":_vm.$route.params.id,"bankid":_vm.$route.params.id,"upload":!_vm.readOnly}})
}
var staticRenderFns = []

export { render, staticRenderFns }